import styles from "../UnauthorizedPage/UnauthorizedPage.module.css";
import {Stack, StackItem} from "@fluentui/react";
import strings from "../../loc/strings";
import React from "react";

const PageNotFound = () => {
  return (
      <Stack className={styles.mainLayout}>
          <StackItem className={styles.mainContent}>
              <div>
                  <h2>{strings.pageNotFound}</h2>
                  <p>{strings.pageNotFoundText}</p>
              </div>
          </StackItem>
      </Stack>
  );
}

export default PageNotFound;